

import React from 'react'
import Newnavbar from './Newnavbar'
import Newfooter from './Newfooter'
import sidephone from '../Images/sidephone.png'



const InvestorRelations = () => {



  return (
    <div>
            <Newnavbar />


              <div className="banner_img !py-5">
                <div className="!flex !flex-row !container !mx-auto !py-5">
                    <div className="md:!w-[70%] !w-[100%] !mx-auto px-[20px]">
                        <div className="new_ban_des !flex !justify-center !flex-col">
                            <h2 className="!text-center md:!text-[42px] !text-[20px]">
                                Investor Relations
                            </h2>
                            <p className="!text-center !text-[#E3E1D8]">
                                At PayBi, we are on a mission to transform the way individuals and businesses manage money. With a focus on transparency, innovation, and financial inclusion, we are building a strong foundation for long-term growth—and we welcome visionary investors to be part of our journey.
                            </p>
                        </div>
                    </div>
                </div>
            </div>


            <div className=" bg-stone-50 flex flex-col">
              <main className="flex-grow nd:py-[60px] py-[30px] ">
                <div className='flex justify-between items-center md:flex-row flex-col w-full  max-w-7xl mx-auto'>
                    <section className=" flex flex-col justify-between trust_below_des leading-relaxed md:space-y-[60px] space-y-[30px] md:mt-[20px] mt-[0px] px-[20px]">
                      <div>
                        <p className="md:!text-[32px] py-2 !text-[24px] !font-bold !text-gray-900 ">
                          Growth Highlights
                        </p>
                        <div>
                          <ul className='!space-y-[10px] list-disc !ml-6 '>
                            <li className='!text-[#525252] text-start '>User adoption growing month-over-month</li>
                            <li className='!text-[#525252] text-start'>Partnerships with key industry players</li>
                            <li className='!text-[#525252] text-start '>Expansion into B2B and corporate expense solutions</li>
                            <li className='!text-[#525252] text-start '>Product roadmap with multi-market scalability</li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <p className="md:!text-[32px] py-2 !text-[24px] !font-bold !text-gray-900 ">
                          Why Invest in PayBi?
                        </p>
                        <div>
                          <ul className='!space-y-[10px] list-disc !ml-6 '>
                            <li className='!text-[#525252] text-start '>Fast-growing fintech segment</li>
                            <li className='!text-[#525252] text-start'>Scalable business model with recurring revenue</li>
                            <li className='!text-[#525252] text-start '>Strong customer retention and engagement</li>
                            <li className='!text-[#525252] text-start '>Experienced founding and advisory team</li>
                            <li className='!text-[#525252] text-start '>Future-ready platform with AI-powered financial tools</li>
                          </ul>
                        </div>
                      </div>
                      
                    </section>

                    <div>
                        <div className="hidden md:block">
                            <img src={sidephone} alt="Edge" className="!mx-auto" />
                        </div>
                    </div>

                     <div className='trust_below_des'>
                        <p className="md:!text-[32px] py-2 !text-[24px] !font-bold !text-gray-900 ">
                          Our Commitment to Investors
                        </p>
                        <div>
                          <ul className='!space-y-[10px] list-disc !ml-6 '>
                            <li className='!text-[#525252] text-start '>Transparent reporting</li>
                            <li className='!text-[#525252] text-start'>Timely updates and financial disclosures</li>
                            <li className='!text-[#525252] text-start '>Strategic planning and innovation</li>
                            <li className='!text-[#525252] text-start '>Responsible governance</li>
                          </ul>
                        </div>
                      </div>

                    
                </div>

              </main>

    </div>

        <div className='p-[20px]'>
          <div className='bg-[#262626] rounded-[40px] max-w-7xl mx-auto py-[60px] '>
              <div className="new_ban_des !flex !justify-center !flex-col max-w-4xl mx-auto ">
                  <h2 className="!text-center md:!text-[36px] !text-[20px] !leading-relaxed px-[10px]">
                      For investor decks, reports, or to schedule a discussion, contact us at:
                  </h2>
                  <button className="w-fit text-[#262626] mx-auto font-semibold py-2 rounded-[8px] hover:opacity-90 transition-all"
                    style={{
                        background: 'linear-gradient(273deg, #FFC039 -7.66%, #FFD95E 79.62%)'
                    }}
                    >
                    investors@paybi.in
                    </button>
              </div>
          </div>
          </div>

            <Newfooter />
      
    </div>
  )
}

export default InvestorRelations


